<template>
  <div class="post-detail-page">
    <van-nav-bar
      fixed
      placeholder
      border
      left-arrow
      safe-area-inset-top
      title="公告"
      @click-left="back"
    />
    <div class="page-content-wrapper">
      <div class="page-title">
        {{ info.title }}
      </div>
      <div class="page-time"></div>
      <div class="page-content" v-html="info.content">
      </div>
    </div>
  </div>
</template>

<script>
import Notice from '@/apis/Notice';

export default {
  name: 'Detail',
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    async fetchDetail() {
      const res = await Notice.getInfo(this.$route.query.id);
      this.info = res.data;
    },
    back() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variable.scss";
@import "~@/assets/styles/mixins.scss";

::v-deep .van-nav-bar__text {
  color: #fff;
}

.page-content-wrapper {
  height: calc(100vh - 46px);
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: #fff;
  padding: 15px;
  font-size: 12px;
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .page-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: center;
  }
  .page-time {
    margin-bottom: 10px;
    text-align: right;
  }
  .page-content {
    flex-basis: 0;
    flex-grow: 1;
    background: url("~@/assets/images/tree.png") no-repeat;
    background-size: contain;
    font-size: 14px;
    line-height: 1.5;
    color: #595959;
  }
}

</style>
